import { useEffect, useRef } from 'react'

interface UseScrollToTopProps {
  isLoading?: boolean
  componentRendered?: any
  className?: string
}

const SM_BREAKPOINT = 768

const isMobile = () => {
  return window.innerWidth < SM_BREAKPOINT
}

export function useScrollToTop({
  isLoading = false,
  componentRendered,
  className = '.sm\\:mainContent',
}: UseScrollToTopProps) {
  const scrollLockRef = useRef(false)

  useEffect(() => {
    if (
      isMobile() &&
      ((!isLoading && !componentRendered) || (isLoading === false && !scrollLockRef.current))
    ) {
      scrollLockRef.current = true
      const element = document.querySelector(className)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }

    return () => {
      scrollLockRef.current = false
    }
  }, [isLoading, componentRendered, className])
}
